import { team20 } from './CoreTeam20.js';
import { team21 } from './CoreTeam21.js';
import { team22 } from './CoreTeam22.js';
import { team24 } from './CoreTeam24.js';
import {team25} from './CoreTeam25.js';
import {team23} from './CoreTeams23.js';
import {team19} from './CoreTeam19.js'
import { team26 } from './CoreTeam26.js';
export const teamDataMap = {
  "2025-2026": {
    data: team26,
    teamPath: "team25"
  },
  "2024-2025": {
    data: team25,
    teamPath: "team24"
  },
   "2023-2024": {
    data: team24,
    teamPath: "team23"
  },
  "2022-2023": {
    data: team23,
    teamPath: "team22"
  },
   "2021-2022": {
    data: team22,
    teamPath: "team21"
  },
   "2020-2021": {
    data: team21,
    teamPath: "team20"
  },
   "2019-2020": {
    data: team20,
    teamPath: "team19"
  }
  ,
  "2018-2019":{
    data:team19,
    teamPath:"team18"
  }

};